import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DictionaryItemTranslatePipe } from './dictionary-item-translate.pipe';

@NgModule({
  imports: [CommonModule],
  providers: [DictionaryItemTranslatePipe],
  declarations: [DictionaryItemTranslatePipe],
  exports: [DictionaryItemTranslatePipe],
})
export class DictionaryItemTranslateModule {}
